import { __decorate } from "tslib";
import { customElement } from 'lit/decorators.js';
import { LitElement, html } from 'lit';
import { panelStyles } from './styles';
let LitPanel = class LitPanel extends LitElement {
    render() {
        return html `<slot></slot>`;
    }
};
LitPanel.styles = panelStyles;
LitPanel = __decorate([
    customElement('lit-panel')
], LitPanel);
export { LitPanel };
